module.exports = __webpack_public_path__ + "img/login-bkg.bde89f90.jpg";